import { getGlobalTerrainData } from "features/map/GlobalTerrainManager"
import { IconLayer, IconLayerProps } from "@deck.gl/layers"
import { VideoMetadata } from "@nova/slice-video"
import { TerrainExtensionProps } from "@deck.gl/extensions"
import { convertHexStringToRGBArray } from "@nova/util-strings"

export const droneIconColors = [
    "#27BBFF", // blue-500
    "#9A6649", // pubsub-warm-chestnut
    "#578FA2", // pubsub-slate-blue
    "#D29873", // pubsub-sandstone
    "#E29D51", // pubsub-gold-apricot
    "#429A8E", // pubsub-seafoam-green
    "#9AA077", // pubsub-olive-sage
    "#892B64", // pubsub-dark-plum
    "#D07062", // pubsub-pastel-peach
    "#93868F", // pubsub-fossil-grey
] as const
export type DroneIconColors = (typeof droneIconColors)[number]

type VideoDroneLayerProps = IconLayerProps &
    TerrainExtensionProps & {
        color?: DroneIconColors
        isMMA: boolean
    }

export const VideoDroneLayers = ({
    color = droneIconColors[0],
    id,
    isMMA,
    ...rest
}: VideoDroneLayerProps) => [
    new IconLayer({
        ...rest,
        id: `${id}-background`,
        pickable: false,
        opacity: isMMA ? 0 : 100,
        getPosition: (d) => {
            const dimensions = getGlobalTerrainData().terrainState ? 3 : 2
            return d.slice(0, dimensions)
        },
        getIcon: () => ({
            url: "/images/drone-video-icon-background.svg",
            width: 512,
            height: 512,
        }),
        sizeUnits: "pixels",
        sizeScale: 1,
        billboard: false,
        getSize: () => 30,
        parameters: { depthTest: false },
    }),
    new IconLayer({
        ...rest,
        id: `${id}-foreground`,
        pickable: false,
        opacity: 100,
        getPosition: (d) => {
            const dimensions = getGlobalTerrainData().terrainState ? 3 : 2
            return d.slice(0, dimensions)
        },
        getIcon: (d) => ({
            url: isMMA
                ? "/images/mma-icon.svg"
                : Number.isFinite(d[3]) || Number.isFinite(d[4]) || Number.isFinite(d[5])
                  ? "/images/drone-video-icon-foreground.svg"
                  : "/images/drone-video-icon-basic-foreground.svg",
            width: 512,
            height: 512,
            mask: true,
        }),
        getColor: () => convertHexStringToRGBArray(color),
        sizeUnits: "pixels",
        sizeScale: 1,
        getAngle: (d: VideoMetadata) => (Number.isFinite(d[4]) ? -d[4] : 0),
        billboard: false,
        getSize: () => 30,
        parameters: { depthTest: false },
    }),
]
